export default "__VITE_ASSET__pGfvPLhq__"